import React from 'react';
import PropTypes from 'prop-types';

export default class EditableInput extends React.Component
{
	render()
	{
		return (
			<div />
		);
	}

	shouldComponentUpdate(nextProps)
	{
		if (nextProps.value === this.props.value)
			return false;

		return true;
	}
}

EditableInput.propTypes =
{
	value        : PropTypes.string,
	propName     : PropTypes.string.isRequired,
	className    : PropTypes.string,
	classLoading : PropTypes.string,
	classInvalid : PropTypes.string,
	editProps    : PropTypes.any,
	onChange     : PropTypes.func.isRequired
};
